import i18next from 'i18next';

export const buildCoverageOptions = (coverages) => {
    if (!Array.isArray(coverages) || coverages.length === 0) return [];
    return coverages.map((item) => ({ label: item.name, value: item.id }));
};

export const getAppendText = (currencyIso, parameter) =>
    parameter && parseInt(parameter.unit) === 0 ? '%' : currencyIso;

export const getBrandOptions = (brands) => {
    const options = brands.map((item) => ({
        label: item.name,
        value: item.name,
    }));

    return [
        { disabled: true, label: i18next.t('Select a brand'), value: '' },
        ...options,
    ];
};

export const getPreAppendText = (currencySymbol, parameter) =>
    parameter && parseInt(parameter.unit) === 1 ? currencySymbol : null;

export const handleOnBlurField = ({ name, setValue, value }) => {
    if (!value) setValue(name, 0);
};

export const getBlindObjects = (values) => {
    let blindObjects = ['rate'];

    const {
        amount_values,
        parameters_commission_credit,
        parameters_hitch,
        power_values,
    } = values;

    const otherBlindObjects = {
        amount_values,
        commission_credit: parameters_commission_credit,
        hitch: parameters_hitch,
        power_values,
    };

    for (const [key, value] of Object.entries(otherBlindObjects)) {
        if (value && value.isChecked) blindObjects.push(key);
    }

    return blindObjects;
};
